export default __webpack_public_path__ + "static/media/checkSymbol.5807fc97.svg";